import { MY_TEAM_ISACTIVE, MY_TEAM_ISACTIVE_SUCCESS, MY_TEAM_ISACTIVE_FAILED, ALL_MY_TEAM_GET_USERS, MY_TEAM_GET_USERS, MY_TEAM_GET_USERS_SUCCESSFULL, MY_TEAM_GET_USERS_FAILED, MY_TEAM_DELETE_USER, MY_TEAM_DELETE_USER_SUCCESSFULL, MY_TEAM_DELETE_USER_FAILED, MY_TEAM_RESEND_VERIFICATION_EMAIL, MY_TEAM_RESEND_VERIFICATION_EMAIL_SUCCESS, MY_TEAM_RESEND_VERIFICATION_EMAIL_FAILED, GET_SAMPLE_CSV_USERS, GET_SAMPLE_CSV_USERS_SUCCESS, GET_SAMPLE_CSV_USERS_FAILED, POST_CSV_USERS, POST_CSV_USERS_SUCCESS, POST_CSV_USERS_FAILED } from "./actionTypes";


const initialState = {
    loader: false,
    customJSON: null,
    buttonLoader: false,
    usersMyTeam: null,
    successMessage: null,
    errorMessage: null,
    statusSuccess: null,
    statusError: null,
    csvData:null,
    csvDataFailed:null,
    postUserSuccess:null,
    postUsersFailed:null
}
const getUsersReducer = (state = initialState, action) => {

    switch (action.type) {
        case MY_TEAM_GET_USERS:
            state = {
                ...state,
                buttonLoader: true,
                customJSON: action.payload,
                usersMyTeam: null,
                successMessage: null,
                errorMessage: null
            }
            break
        case MY_TEAM_GET_USERS_SUCCESSFULL:
            state = {
                ...state,
                buttonLoader: false,
                usersMyTeam: action.payload,
                successMessage: null,
                errorMessage: null
            }
            break
        case MY_TEAM_GET_USERS_FAILED:
            state = {
                ...state,
                buttonLoader: false,
                usersMyTeam: null,
                successMessage: null,
                errorMessage: action.payload
            }
            break

        case MY_TEAM_DELETE_USER:
            state = {
                ...state,
                buttonLoader: true,
                successMessage: null,
                errorMessage: null
            }
            break

        case MY_TEAM_DELETE_USER_SUCCESSFULL:
            state = {
                ...state,
                buttonLoader: false,
                successMessage: action.payload,
                errorMessage: null
            }
            break
        case MY_TEAM_DELETE_USER_FAILED:
            state = {
                ...state,
                buttonLoader: false,
                successMessage: null,
                errorMessage: action.payload
            }
            break
        case ALL_MY_TEAM_GET_USERS:
            state = {
                ...state,
                buttonLoader: true,
                customJSON: action.payload,
                usersMyTeam: null,
                successMessage: null,
                errorMessage: null
            }
            break
        case MY_TEAM_ISACTIVE_SUCCESS:
            state = {
                ...state,
                buttonLoader: false,
                statusSuccess: action.payload,
                statusError: null
            }
            break
        case MY_TEAM_ISACTIVE_FAILED:
            state = {
                ...state,
                buttonLoader: false,
                statusSuccess: null,
                statusError: action.payload
            }
            break
        case MY_TEAM_ISACTIVE:
            state = {
                ...state,
                buttonLoader: true,
                statusSuccess: null,
                statusError: null
            }
            break

        case MY_TEAM_RESEND_VERIFICATION_EMAIL_SUCCESS:
            state = {
                ...state,
                buttonLoader: false,
                statusSuccess: action.payload,
                statusError: null
            }
            break
        case MY_TEAM_RESEND_VERIFICATION_EMAIL_FAILED:
            state = {
                ...state,
                buttonLoader: false,
                statusSuccess: null,
                statusError: action.payload
            }
            break
        case MY_TEAM_RESEND_VERIFICATION_EMAIL:
            state = {
                ...state,
                buttonLoader: true,
                statusSuccess: null,
                statusError: null
            }
            break
            case GET_SAMPLE_CSV_USERS:
            state = {
                ...state,
                csvData:null,
                csvDataFailed:null
                
            }
            break
            case GET_SAMPLE_CSV_USERS_SUCCESS:
            state = {
                ...state,
                csvData:action.payload,
                csvDataFailed:null
                
            }
            break
            case GET_SAMPLE_CSV_USERS_FAILED:
            state = {
                ...state,
                csvData:null,
                csvDataFailed:action.payload
                
            }
            break
            case POST_CSV_USERS:
            state = {
                ...state,
                postUserSuccess:null,
                postUsersFailed:null
                
            }
            break
            case POST_CSV_USERS_SUCCESS:
            state = {
                ...state,
                postUserSuccess:action.payload,
                postUsersFailed:null
                
                
            }
            break
            case POST_CSV_USERS_FAILED:
            state = {
                ...state,
                postUserSuccess:null,
                postUsersFailed:action.payload
                
                
            }
            break
        default:
            state = { ...state }
            break
    }
    return state
}
export default getUsersReducer